export default "__VITE_ASSET__DtkuHT8c__"